'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FlightLogoCarrierNumber = require('./FlightLogoCarrierNumber.jsx');

var _FlightLogoCarrierNumber2 = _interopRequireDefault(_FlightLogoCarrierNumber);

var _Departure = require('./Departure.jsx');

var _Departure2 = _interopRequireDefault(_Departure);

var _Arrival = require('./Arrival.jsx');

var _Arrival2 = _interopRequireDefault(_Arrival);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TransportationDetails(props) {
  var segment = props.segment;
  var components = props.components;


  var styleFlightContainer = {};
  styleFlightContainer.backgroundColor = components.FlightContainer.backgroundColor;

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TransportationDetails' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleFlightContainer, { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TransportationDetails_Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '10px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '20%' } },
                  _react2.default.createElement(_FlightLogoCarrierNumber2.default, {
                    logo: {},
                    carrierCode: segment.carrier.code,
                    number: segment.flightNumber,
                    logoUrl: segment.logoUrl
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '5px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '40%' } },
                  _react2.default.createElement(_Departure2.default, {
                    airportName: segment.origin.name,
                    airportCode: segment.origin.code,
                    city: segment.origin.cityName,
                    terminal: segment.originTerminal,
                    time: segment.startDateTime
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '0', paddingBottom: '0', paddingLeft: '5px', verticalAlign: 'top', width: '40%' } },
                  _react2.default.createElement(_Arrival2.default, {
                    airportName: segment.destination.name,
                    airportCode: segment.destination.code,
                    city: segment.destination.cityName,
                    terminal: segment.destinationTerminal,
                    time: segment.endDateTime
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(TransportationDetails);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/TransportationDetails.jsx
// module id = 1490
// module chunks = 0